import React, { Suspense, useEffect, useRef, useState } from "react";

import { Outlet } from "react-router-dom";

/** Lib Imports */
import Toast from "@moltech/molui/toast";
import { Button } from "primereact/button";

import Header from "./Header";
import Sidebar from "./Sidebar";
import { securityKeys } from "../enums/SecurityKeys.ENUM";

/** Components */
import AddApplicants from "../pages/applicants/AddApplicants";

import PageLoader from "../components/common/page-loader/PageLoader";

import { hasFunctionalPermission } from "../utils/authentication/authorizeNavigation";
import useSignalRNotifications from "../app/hooks/useSignalRNotifications";
import { CopilotShellProvider, useCopilotShell } from "../components/copilot/CopilotShellContext";
import CopilotDrawer from "../components/copilot/CopilotDrawer";

const MolAssistFloatingTrigger = () => {
  const { toggleDrawer, drawerVisible } = useCopilotShell();
  const canUseMolAssist = hasFunctionalPermission(securityKeys.RECRUITMENT_AI_ASSISTANT)?.isEditable;

  if (!canUseMolAssist) return null;

  return (
    <Button
      className={`molassist-floating-btn${drawerVisible ? " is-active" : ""}`}
      icon={drawerVisible ? "pi pi-times" : "pi pi-sparkles"}
      tooltip={drawerVisible ? "Close MolAssist" : "MolAssist"}
      data-pr-position="left"
      onClick={toggleDrawer}
    />
  );
};

const Layouts = () => {
  useSignalRNotifications();
  const addApplicantRef = useRef();



  const [isClosed, setIsClosed] = useState(window.innerWidth <= 1024);
  const [openMenus, setOpenMenus] = useState({});
  const [applicantData, setApplicantData] = useState(null);

  const hasAddPermission = hasFunctionalPermission(securityKeys.ADD_APPLICANT);

  const handleClose = () => { };

  const onCallback = (data) => {
    if (data) {
      Toast.success(data.message);
    }
  };

  const openEdit = (rowData) => {
    setApplicantData(rowData);
    addApplicantRef.current.show();
  };

  const toggleMenu = (index, forceOpen = false) => {
    setOpenMenus((prev) => {
      if (forceOpen) {
        return {
          ...prev,
          [index]: true,
        };
      }
      const isOpen = prev[index];
      return {
        [index]: !isOpen,
      };
    });


  };



  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024) {
        setIsClosed(true);
      } else {
        setIsClosed(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <CopilotShellProvider>
    <div className="layout-root">
      <div
        className={`layout-content-row ${isClosed ? "sidebar-collapsed" : ""}`}
      >
        <div className="sidebar-main-sec">
          <Sidebar
            isClosed={isClosed}
            openMenus={openMenus}
            toggleMenu={toggleMenu}
            closeSidebar={() => setIsClosed(true)}
          />
          <div></div>
        </div>

        {!isClosed && (
          <button
            type="button"
            className="mobile-sidebar-backdrop"
            aria-label="Close sidebar"
            onClick={() => setIsClosed(true)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " " || e.key === "Escape") {
                e.preventDefault();
                setIsClosed(true);
              }
            }}
          />
        )}

        <div className="main-content">
          <Header
            isClosed={isClosed}
            toggleSidebar={() => setIsClosed(!isClosed)}
            prev
          />
          <div className="middle-content">
            <Suspense
              fallback={
                <div>
                  {/* <LoadingScreen /> */}
                  <PageLoader />
                </div>
              }
            >
              <Outlet />
            </Suspense>
          </div>

          <div className="layout-add-candidate-btn right-btn-part">
            <MolAssistFloatingTrigger />
            <Button
              className="btn secondary-btn "
              icon="pi pi-plus"
              tooltip="Add Candidate"
              data-pr-position="left"
              disabled={!hasAddPermission?.isEditable}
              onClick={() => openEdit()}
            />
          </div>

          <AddApplicants
            ref={addApplicantRef}
            applicantData={applicantData}
            onClose={handleClose}
            onCallback={onCallback}
            dialogProps={{
              position: "center",
              resizable: false,
              draggable: false,
              style: { width: "58rem", maxWidth: "95vw" },
              className: "add-applicant-dialog",
            }}
          />
        </div>
      </div>
      <CopilotDrawer />
    </div>
    </CopilotShellProvider>
  );
};

export default Layouts;
